import { render, staticRenderFns } from "./stepHeader.vue?vue&type=template&id=bccf7280&scoped=true"
import script from "./stepHeader.vue?vue&type=script&lang=js"
export * from "./stepHeader.vue?vue&type=script&lang=js"
import style0 from "./stepHeader.vue?vue&type=style&index=0&id=bccf7280&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bccf7280",
  null
  
)

export default component.exports